import { ISubformInlineEditPublishObj } from '../DexeroForm/onSubformInlineEdit';
import { IExtraInfo } from '../@types/DexeroFD';

interface IPostPair {
  name: string;
  value: any;
}
interface IFileObj {
  fileName: string;
  fileUrl: string;
}

function closeInlineEdit($wrapper: JQuery) {
  const $accessibleDatepickerGroup = $wrapper.find('.accessible-datepicker-wrapper');
  const $fileName = $wrapper.find('.file-name-inline-edit');
  const $editableFieldWrapper = $wrapper.find('.editable-field-wrapper');

  $wrapper.stop();
  window.DexeroCoreApp.highlightElm($wrapper);
  $wrapper.removeClass('open');

  $editableFieldWrapper.attr('aria-hidden', 'true');

  if ($accessibleDatepickerGroup.length) {
    $accessibleDatepickerGroup.attr('aria-hidden', 'true');
  }
  if ($fileName.length) {
    cancelDeleteFileInlineEdit($wrapper);
  }
}

function openInlineEdit($wrapper: JQuery) {
  const $staticSpan = $wrapper.find('.static');
  const $fileName = $wrapper.find('.file-name-inline-edit');
  const value = $staticSpan.data('value');
  const valueListIdent = $staticSpan.data('value-listident');
  const $input = $fileName.length
    ? $wrapper.find(':input:file')
    : $wrapper.find(':input:not(:button)').first();
  const isSelect = $input.is('select');
  const isFile = $input.is('input:file');
  const isHyperlink = $input.hasClass('hyper-link-part-1');
  const isRadio = $input.is(':radio') || $input.is(':checkbox');
  const $accessibleDatepickerGroup = $wrapper.find('.accessible-datepicker-wrapper');
  const $deleteFileInlineEditButton = $wrapper.find('.delete-file-inline-edit');
  const $editableFieldWrapper = $wrapper.find('.editable-field-wrapper');

  let $fieldSet;
  let $allRadios;
  let $siblingInput: JQuery;

  $wrapper.stop();

  $editableFieldWrapper.attr('aria-hidden', 'false');
  if ($accessibleDatepickerGroup.length) {
    $accessibleDatepickerGroup.attr('aria-hidden', 'false');
  }
  window.DexeroCoreApp.highlightElm($wrapper);
  $wrapper.addClass('open');

  if (isHyperlink) {
    $siblingInput = $input.closest('.display-as-table').find('.hyper-link-part-2');
    $input.find('option').each((_, opt) => {
      const protocolText = $(opt).text();
      if (value.indexOf(protocolText) === 0) {
        $input.val(protocolText);
        $siblingInput.val(value.substr(protocolText.length));
      }
    });
  } else if (isSelect) {
    $input.val(valueListIdent.join(',')).attr('value', valueListIdent.join(','));
  } else if (isRadio) {
    $fieldSet = $input.closest('fieldset');
    $allRadios = $fieldSet.find(':input');
    $allRadios.each((_, elm) => {
      if (valueListIdent.indexOf(Number($(elm).val())) !== -1) {
        $(elm).prop('checked', true);
      }
    });
  } else if (isFile) {
    if ($staticSpan.data('value') === '') {
      $deleteFileInlineEditButton.addClass('hide');
    }
  } else {
    $input.val(value).attr('value', value);
  }
  $input.focus();
}

function toggleInlineEdit($wrapper: JQuery, focus?: boolean) {
  const isOpen = $wrapper.hasClass('open');
  const $fileName = $wrapper.find('.file-name-inline-edit');
  const $input = $fileName.length
    ? $wrapper.find(':input:file')
    : $wrapper.find(':input:not(:button)').first();

  if (isOpen) {
    closeInlineEdit($wrapper);
  } else {
    openInlineEdit($wrapper);
  }
  if (focus) {
    $input.focus();
  }
}

function processInlineEdit($wrapper: JQuery) {
  const publish = $wrapper.data('publish') || false;
  const publishData: any[] =
    $wrapper.data('publish-data') && typeof $wrapper.data('publish-data') === 'string'
      ? JSON.parse(decodeURIComponent($wrapper.data('publish-data')))
      : [];
  // If you want to pass more params into other functions which will be published, just create params object
  const info: ISubformInlineEditPublishObj =
    $wrapper.data('info') && typeof $wrapper.data('info') === 'string'
      ? JSON.parse(decodeURIComponent($wrapper.data('info')))
      : false;
  const tdParams = $wrapper.data('params') || {};
  const params = typeof tdParams === 'string' ? JSON.parse(decodeURIComponent(tdParams)) : tdParams;
  const $fileName = $wrapper.find('.file-name-inline-edit');
  const $inlineEditFileA = $wrapper.find('.inline-edit-file-a');
  const $deleteFileInlineEdit = $wrapper.find('.delete-file-inline-edit');
  const $input = $fileName.length
    ? $wrapper.find(':input:file')
    : $wrapper.find(':input:not(:button)').first();
  const $inputReset = $wrapper.find(':input[name$="_reset"]');
  const $autocompleteInput = $wrapper.find(':input[name^="auto_"]');
  const $accessibleDatepickerGroup = $wrapper.find('.accessible-datepicker-wrapper');
  const isSelect = $input.is('select');
  const isRadio = $input.is(':radio') || $input.is(':checkbox');
  const isFile = $input.is('input:file');
  const isHyperlink = $input.hasClass('hyper-link-part-1');
  const uuid = $wrapper.data('uuid');
  const $staticSpan = $wrapper.find('.static');
  const valueListIdent = $staticSpan.data('value-listident');
  const oldValue = $staticSpan.data('value');
  const postData: IPostPair[] = [];
  let fieldName = $input.attr('name') as string;

  let overrideDisplayValue = false;
  let value: string;
  let displayValue = '';
  let $fieldSet;
  let $allRadios: JQuery<HTMLElement>;
  let $siblingInput: JQuery<HTMLElement>;
  let allRadiosValues: string;
  let doFileReset;

  if (isHyperlink) {
    $siblingInput = $input.closest('.display-as-table').find('.hyper-link-part-2');
    value =
      !$siblingInput.val() || $siblingInput.val() === ''
        ? ''
        : `${$input.val() as string}${$siblingInput.val() as string}`;
    fieldName = $siblingInput.attr('name') as string;
  } else if (isSelect) {
    value = $input.val() as string;
    displayValue = $input.find('option:selected').text();
    overrideDisplayValue = true;
  } else if ($input.hasClass('percent-field')) {
    value = $input.val() as string;
    displayValue = `${value} %`;
    overrideDisplayValue = true;
  } else if ($input.hasClass('money-field')) {
    value = $input.val() as string;
    displayValue = `${value} $`;
    overrideDisplayValue = true;
  } else if (isRadio) {
    $fieldSet = $input.closest('fieldset');
    $allRadios = $fieldSet.find(':input');

    const temp: string[] = [];
    $allRadios.each((_, elm) => {
      const $elm = $(elm);
      if ($elm.is(':checked')) {
        temp.push($elm.val() as string);
      }
    });

    allRadiosValues = temp.join(',');

    displayValue = $allRadios
      .filter((_, elm) => {
        const $elm = $(elm);
        return $elm.is(':checked');
      })
      .map((_, elm) => {
        const $elm = $(elm);
        return $elm.closest('label').text();
      })
      .get()
      .join(',');
    value = allRadiosValues;
    overrideDisplayValue = true;
  } else if ($autocompleteInput.length) {
    value = !$input.val() && $input.val() === oldValue ? 'empty' : ($input.val() as string);
    displayValue = $autocompleteInput.val() as string;
    overrideDisplayValue = true;
  } else if (isFile) {
    doFileReset = String($inputReset.val()) === 'true';
    if (doFileReset) {
      postData.push({ name: $inputReset.attr('name') as string, value: 'true' });
      value = '';
      displayValue = '';
    } else {
      value = ($input[0] as HTMLFormElement).files.length
        ? ($input[0] as HTMLFormElement).files[0]
        : '';
      displayValue = typeof value === 'object' ? (value as any).name : '';
    }
    // input:text
  } else {
    value = $input.val() as string;
    displayValue = value;
  }

  function getNewFileObj() {
    if (!isFile) {
      return Promise.resolve(false);
    }
    async function getFileUrl() {
      if (!info) {
        return { fileName: 'WARNING: MISSING DATA-INFO', fileUrl: '#' };
      }
      const { fieldIdentifier, formIdentifier, formLocale } = info;
      const { ownerIdentifier } = window.DexeroCoreApp.userOptions;
      const swaggerClient = await window.DexeroCoreApp.getSwaggerClient();
      const swaggerObj = { formIdentifier, uuid, ownerIdentifier, lang: formLocale };
      const cardResponse = await swaggerClient.apis.cards.getCard(swaggerObj);
      const card = cardResponse.body;

      const fields = card.cardFields;
      const obj = { fileName: '', fileUrl: '' };
      Object.keys(fields).some(fieldIdent => {
        const field = fields[fieldIdent];
        const { identifier, values } = field;
        if (identifier === fieldIdentifier) {
          if (values && values.length && Object.hasOwnProperty.call(values[0], 'extraInfo')) {
            obj.fileName = (values[0].extraInfo as IExtraInfo).filename;
            obj.fileUrl = (values[0].extraInfo as IExtraInfo).downloadUrl;
          }
          return true;
        }
        return false;
      });

      return obj;
    }
    return getFileUrl();
  }

  function onSuccess(newFileObj: IFileObj | boolean) {
    window.DexeroCoreApp.userToastMsg(
      'success',
      'Données enregistrées',
      'La valeur a été enregistrée avec succès.'
    );
    if (isFile) {
      const { fileName, fileUrl } = newFileObj as IFileObj;
      $inlineEditFileA.text(fileName).attr('href', fileUrl);
      $fileName.text(fileName);
      $staticSpan.data('value', fileName).attr('data-value', fileName);
      $deleteFileInlineEdit.removeClass('hide');
      $input.val('');
      $inputReset.val('false');
    } else if (isHyperlink) {
      $staticSpan
        .empty()
        .removeData('value')
        .data('value', value)
        .attr('data-value', value)
        .html(`<a href="${value}" target="_blank">${value}</a>`);
    } else if (overrideDisplayValue) {
      $staticSpan
        .empty()
        .text(displayValue)
        .removeData('value')
        .data('value', displayValue)
        .attr('data-value', displayValue)
        .removeData('value-listident')
        .data('value-listident', value)
        .attr('data-value-listident', value);
    } else {
      $staticSpan
        .empty()
        .html(value)
        .data('value', value)
        .attr('data-value', value);
    }
    if ($accessibleDatepickerGroup.length) {
      $accessibleDatepickerGroup.attr('aria-hidden', 'true');
    }
    $wrapper.removeClass('open error').addClass('highlight-effect', 400, 'easeOutQuint', () => {
      $wrapper.removeClass('highlight-effect', 200, 'easeOutQuint');
    });
    if (publish) {
      params.oldValue = oldValue;
      params.newValue = value;
      params.tdElement = $wrapper;
      publishData.unshift(params);

      window.DexeroCoreApp.publish(publish, publishData);
    }
  }

  function onFail() {
    $wrapper.addClass('error');
    window.DexeroCoreApp.userToastMsg(
      'error',
      'Impossible de sauvegarder',
      "Impossible d'enregistrer la valeur que vous avez entrée."
    );
  }

  function doSave() {
    postData.push({ name: 'uuid', value: uuid });
    postData.push({ name: fieldName, value });
    window.DexeroCoreApp.blockUI($wrapper);
    saveInlineEdit($wrapper, postData).done((response: any) => {
      if (response.success === 'true') {
        (getNewFileObj() as any).then((newFileUrl: IFileObj | boolean) => onSuccess(newFileUrl));
      } else {
        onFail();
      }
      window.DexeroCoreApp.unblockUI($wrapper);
    });
  }

  function cancelSave(error?: string, message?: string) {
    if (error === 'sameValue') {
      closeInlineEdit($wrapper);
      return;
    }
    if (error === 'nonNumber') {
      window.DexeroCoreApp.userToastMsg(
        'error',
        'Impossible de sauvegarder',
        "Impossible d'enregistrer la valeur que vous avez entrée."
      );
    } else if (error === 'noTotals') {
      window.DexeroCoreApp.userToastMsg(
        'error',
        'Une erreur est survenue',
        'Incapable de récupérer les périodes de paie.'
      );
    } else if (error === 'totalTooHigh') {
      window.DexeroCoreApp.userToastMsg('error', 'Impossible de sauvegarder', message);
    }
    $wrapper.addClass('error');
  }

  // Check if we are dealing with numbers, if so format 10.00
  if ($input.attr('data-type')) {
    if ($input.data('type') === 'number') {
      value = parseFloat(value).toFixed(2);
    }
  }

  // If value entered is same as old value stop processing
  if (
    (isSelect && valueListIdent.toString() === value.toString()) ||
    (isFile && !doFileReset && value === '') ||
    (overrideDisplayValue && oldValue.toString() === String(displayValue)) ||
    oldValue.toString() === value.toString()
  ) {
    cancelSave('sameValue');
    return;
  }

  // Check to see if data should be equal to a default value
  if ($wrapper.attr('data-verify')) {
    if (value.toString() !== $wrapper.data('verify').toString()) {
      $wrapper.addClass('attention');
    } else {
      $wrapper.removeClass('attention');
    }
  }
  doSave();
}

function saveInlineEdit($wrapper: JQuery, postData?: IPostPair[]) {
  const saveUrl = $wrapper.data('save-url');
  const { langObj = {} } = window.DexeroCoreApp.userOptions;

  const formData = new FormData();
  formData.append('ajax', 'true');
  formData.append('partialSave', 'true');
  formData.append('waitForEvent', 'true');
  if (postData) {
    for (const obj of postData) {
      formData.append(obj.name, obj.value);
    }
  }

  return $.ajax({
    cache: false,
    contentType: false,
    data: formData,
    error(jqXHR, textStatus, errorThrown) {
      if (textStatus === 'timeout') {
        const errorTitle = langObj.errorText;
        const errorMessage = langObj.unableToLoadPageText;
        window.DexeroCoreApp.userToastMsg('error', errorTitle, errorMessage);
      }
    },
    processData: false,
    timeout: 90000,
    type: 'POST',
    url: saveUrl,
  });
}

function deleteFileInlineEdit($wrapper: JQuery) {
  const $input = $wrapper.find(':input:file');
  const $inputReset = $wrapper.find(':input[name$="_reset"]');
  const $fileName = $wrapper.find('.file-name-inline-edit');
  const $deleteFileInlineEditButton = $wrapper.find('.delete-file-inline-edit');
  $deleteFileInlineEditButton.addClass('hide');
  $input.val('');
  $inputReset.val('true');
  $fileName.text('');
}

function cancelDeleteFileInlineEdit($wrapper: JQuery) {
  const $staticSpan = $wrapper.find('.static');
  const $inputReset = $wrapper.find(':input[name$="_reset"]');
  const $fileName = $wrapper.find('.file-name-inline-edit');
  const $deleteFileInlineEditButton = $wrapper.find('.delete-file-inline-edit');
  $deleteFileInlineEditButton.removeClass('hide');
  $inputReset.val('false');
  $fileName.text($staticSpan.data('value'));
}

function handleInlineEditKeydown(event: JQuery.KeyDownEvent) {
  const key = event.which || event.charCode || event.keyCode;
  if (key === 13) {
    // Enter key
    event.preventDefault();
    const $wrapper = $(event.currentTarget).closest('.inline-edit-wrapper');
    if ($wrapper.hasClass('open')) {
      $wrapper.find('.confirm-inline-edit').trigger('click');
    }
  }
  if (key === 27) {
    // Escape key
    const $wrapper = $(event.currentTarget).closest('.inline-edit-wrapper');
    if ($wrapper.hasClass('open')) {
      $wrapper.find('.cancel-inline-edit').trigger('click');
    }
  }
}

export type IInlineEditBindings = IDCA.IGenericFunc;

export default function inlineEditBindings() {
  $('body')
    .off('click', '.inline-edit-wrapper:not(.open):not(.html-textarea):not(.disabled)')
    .on('click', '.inline-edit-wrapper:not(.open):not(.html-textarea):not(.disabled)', e => {
      toggleInlineEdit($(e.currentTarget));
    })
    .off('click', '.inline-edit-file-a')
    .on('click', '.inline-edit-file-a', e => {
      e.stopPropagation();
    })
    .off('click', '.open-inline-edit:not(.disabled)')
    .on('click', '.open-inline-edit:not(.disabled)', e => {
      e.stopPropagation();
      openInlineEdit($($(e.currentTarget).data('target')));
    })
    .off('click', '.confirm-inline-edit')
    .on('click', '.confirm-inline-edit', e => {
      e.stopPropagation();
      processInlineEdit($($(e.currentTarget).data('target')));
    })
    .off('click', '.cancel-inline-edit')
    .on('click', '.cancel-inline-edit', e => {
      e.stopPropagation();
      closeInlineEdit($($(e.currentTarget).data('target')));
    })
    .off('keydown', '.inline-edit-wrapper input[type="text"]')
    .on('keydown', '.inline-edit-wrapper input[type="text"]', e => {
      handleInlineEditKeydown(e);
    })
    .off('click', '.delete-file-inline-edit')
    .on('click', '.delete-file-inline-edit', e => {
      e.stopPropagation();
      deleteFileInlineEdit($($(e.currentTarget).data('target')));
    });
}
